import { parseNumber } from '@woovi/form';

export const convertToCents = (
  value?: string | null,
  { prefix = 'R$', ...options } = {},
) => {
  if (!value) {
    return null;
  }

  const money = parseNumber(value.replace(prefix, ''), options);

  const cents = money ? Math.round(money * 100) : money;

  return cents;
};
